import {InstrumentQueryStatus} from './InstrumentDataConstants';
import {createBrowseFilesInstrumentQuery, pollInstrumentQueryStatus} from './InstrumentDataDAO';

export type FileListingRefreshResult = {succeeded: true} | {succeeded: false; errorMessage: string};

/**
 * Refreshes the connection's file listing with BROWSE_FILES, as the logged-in user when given a username.
 * Resolves to the message to show the user if the listing couldn't be refreshed.
 */
export default function refreshConnectionFileListing(
  connectionId: string,
  username?: string
): Promise<FileListingRefreshResult> {
  return createBrowseFilesInstrumentQuery(connectionId, username)
    .then(({instrumentQueryId}) => pollInstrumentQueryStatus(instrumentQueryId))
    .then((query): FileListingRefreshResult => {
      if (query.status === InstrumentQueryStatus.DONE) {
        return {succeeded: true};
      }
      const detail = query.info || 'An unknown error occurred';
      return {succeeded: false, errorMessage: `Failed to retrieve file listing from connection: "${detail}"`};
    })
    .catch((error: unknown): FileListingRefreshResult => {
      const isTimeout = error instanceof Error && error.message.includes('Polling failed');
      if (isTimeout) {
        return {succeeded: false, errorMessage: 'File listing request timed out. Please try again later.'};
      }
      // jQuery XHR rejections include responseJSON with server error details
      const serverMessage = (error as {responseJSON?: {userMessage?: string}})?.responseJSON?.userMessage;
      if (serverMessage) {
        return {
          succeeded: false,
          errorMessage: `Failed to retrieve file listing from connection: "${serverMessage}"`,
        };
      }
      return {
        succeeded: false,
        errorMessage:
          'Failed to retrieve file listing from connection. Please contact Benchling support if the issue persists.',
      };
    });
}
